import * as Mixpanel from 'mixpanel-browser';
import { TIGHT_KNIT_MIXPANEL_TOKEN } from 'src/Config/Environment';

export class MixpanelService {
    private static initialized = false;

    public static getClient(): typeof Mixpanel | undefined {
        if (!MixpanelService.initialized) {
            if (TIGHT_KNIT_MIXPANEL_TOKEN.length > 0) {
                Mixpanel.init(TIGHT_KNIT_MIXPANEL_TOKEN);
                MixpanelService.initialized = true;
            } else {
                return;
            }
        }
        return Mixpanel;
    }
}



// WEBPACK FOOTER //
// ./src/util/MixpanelService.ts